import { TypeUtils } from '../../common/misc';

export default class SettingsUtils {
    static ensureSqlScriptIdsConfigured(
        appSettings: Record<string, unknown> | undefined,
        sqlScriptIds: string[]
    ): boolean {
        if (!appSettings || !sqlScriptIds.length) {
            return false;
        }

        return sqlScriptIds.every(sqlScriptId => {
            const value = appSettings[sqlScriptId];
            return TypeUtils.isString(value) && value.trim().length > 0;
        });
    }
}
